import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import './CloudProcess.css';

const processes = [
  {
    icon: <AssessmentIcon sx={{ fontSize: 40 }} />,
    title: 'Assessment & Planning',
    description: 'Comprehensive evaluation of your current infrastructure and detailed migration planning.',
    highlights: ['Infrastructure Analysis', 'Cost Optimization', 'Risk Assessment']
  },
  {
    icon: <ArchitectureIcon sx={{ fontSize: 40 }} />,
    title: 'Cloud Architecture Design',
    description: 'Designing scalable and efficient cloud architecture tailored to your needs.',
    highlights: ['Solution Design', 'Resource Planning', 'Architecture Review']
  },
  {
    icon: <CloudSyncIcon sx={{ fontSize: 40 }} />,
    title: 'Migration & Implementation',
    description: 'Seamless migration of your applications and data to the cloud environment.',
    highlights: ['Data Migration', 'Application Transfer', 'Zero Downtime']
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 40 }} />,
    title: 'Security & Compliance',
    description: 'Implementing robust security measures and ensuring regulatory compliance.',
    highlights: ['Security Setup', 'Compliance Check', 'Access Control']
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: 'Optimization',
    description: 'Fine-tuning cloud resources for optimal performance and cost efficiency.',
    highlights: ['Performance Tuning', 'Cost Management', 'Resource Scaling']
  },
  {
    icon: <MonitorHeartIcon sx={{ fontSize: 40 }} />,
    title: 'Monitoring & Support',
    description: '24/7 monitoring and support to ensure smooth cloud operations.',
    highlights: ['Continuous Monitoring', 'Proactive Support', 'Regular Updates']
  }
];

const CloudProcess = () => {
  return (
    <section className="cloud-process">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="cloud-process-header"
        >
          <Typography variant="h2" className="cloud-process-title" gutterBottom>
            Our Cloud Implementation Process
          </Typography>
          <Typography variant="subtitle1" className="cloud-process-subtitle" gutterBottom>
            A systematic approach to cloud transformation
          </Typography>
        </motion.div>

        <Box className="cloud-process-container">
          {processes.map((process, index) => (
            <motion.div
              key={index}
              className="cloud-process-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="cloud-process-content">
                <div className="cloud-process-icon">
                  {process.icon}
                </div>
                <Typography variant="h6" className="cloud-process-step-title">
                  {process.title}
                </Typography>
                <Typography variant="body2" className="cloud-process-description">
                  {process.description}
                </Typography>
                <div className="cloud-process-highlights">
                  {process.highlights.map((highlight, idx) => (
                    <span key={idx} className="cloud-process-highlight">
                      {highlight}
                    </span>
                  ))}
                </div>
                <div className="cloud-process-number">{index + 1}</div>
              </div>
            </motion.div>
          ))}
        </Box>
      </Container>
    </section>
  );
};

export default CloudProcess; 